export * from "./SegmentedControl.settings";
